


import React, { useState } from "react";

const gallery = [
  
  { image: "/images/gallery/11.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/23.jpeg", title: "Swift Dzire" },

  { image: "/images/gallery/12.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/13.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/14.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/15.jpeg", title: "Swift Dzire" },

  { image: "/images/gallery/2.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/3.jpeg", title: "Swift Dzire" },
  // { image: "/images/gallery/5.jpeg", title: "Swift Dzire" },
    { image: "/images/Fleet/bus.jpeg", title: "Swift Dzire" },
      { image: "/images/Fleet/bus-1.jpeg", title: "Swift Dzire" },
        { image: "/images/Fleet/bus-3.jpeg", title: "Swift Dzire" },
  // { image: "/images/gallery/6.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/7.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/8.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/1.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/16.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/17.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/18.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/19.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/20.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/21.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/22.jpeg", title: "Swift Dzire" },

  // { image: "/images/gallery/9.jpeg", title: "Swift Dzire" },
  { image: "/images/gallery/10.jpeg", title: "Swift Dzire" },

{
  image: "/images/Fleet/Swift-Dzire.jpeg",
  title: "Swift Dzire",
},
{
  image: "/images/Fleet/Maruti-Ertiga.jpg",
  title: "Maruti Ertiga",
},
{
  image: "/images/Fleet/Toyota-Rumion.jpg",
  title: "Toyota Rumion",
},
{
  image: "/images/Fleet/Kia-Carens.jpg",
  title: "Kia Carens",
},
{
  image: "/images/Fleet/Innova-Cab.jpg",
  title: "Innova Cab",
},
{
  image: "/images/Fleet/Innova-Crysta.jpeg",
  title: "Innova Crysta",
},
{
  image: "/images/Fleet/Tempo-Traveller.jpg",
  title: "Tempo Traveller",
},
{
  image: "/images/Fleet/Urbania-Bus.jpg",
  title: "Urbania Bus",
},
// {
//   image: "/images/Fleet/Mini-Bus.jpg",
//   title: "Mini Bus",
// },

];
const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openImage = (index) => {
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === gallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? gallery.length - 1 : prev - 1
    );
  };

  return (
    <>
       

 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Gallery
        </h2>
      </div>
    </section>
    


      <div className="container py-5">
        <div className="row">
          {gallery.map((item, index) => (
         
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
  <div className="fleetCard" onClick={() => openImage(index)}>

    {/* <div className="fleetBadge">
      Garud Cab 
    </div> */}

    <div className="fleetImage">
      <img src={item.image} alt={item.name} />
    </div>

    <div className="fleetContent">
      <h4>{item.name}</h4>

      <div className="fleetBottom">
        <span>Comfort Ride</span>

        <button>
          View
          <i className="fas fa-arrow-right"></i>
        </button>
      </div>
    </div>

  </div>
</div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox">
          <span className="close darkcolorrrr" onClick={closeImage}>✖</span>

          <span className="prev" onClick={prevImage}>❮</span>
          <img
            src={gallery[currentIndex].image}
            alt="preview"
            className="lightbox-img "
          />
          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </>
  );
};

export default Gallery;